import classNames from "classnames/bind";
import { ReactNode } from "react";
import { Header, Paragraph } from "@datagame/ui";

import styles from "./Section.module.scss";

const cx = classNames.bind(styles);

export interface SectionProps {
  title: string;
  subheader?: string;
  tip?: string | null | ReactNode;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  headerContainerClassName?: string;
  tooltip?: ReactNode;
}

export const Section = ({
  title,
  subheader,
  tip,
  children,
  className,
  headerClassName,
  headerContainerClassName,
  tooltip,
}: SectionProps) => {
  return (
    <div className={cx("section", className)}>
      <div className={cx("headerContainer", headerContainerClassName)}>
        <Header className={cx("header", headerClassName)} variant="h6">
          {title}
        </Header>

        {tooltip}
      </div>

      {subheader && (
        <Paragraph size="small" className={styles.subheader}>
          {subheader}
        </Paragraph>
      )}
      {children}
      {tip && (
        <Paragraph size="small" className={styles.tip}>
          {tip}
        </Paragraph>
      )}
    </div>
  );
};
